import './App.css';
import Navbar from './component/Navbar';
import ProductList from './component/ProductList';
import React,{useState} from 'react';
import Footer from './component/Footer'
import AddItem from './component/addItem';
import {Toaster} from 'react-hot-toast';

function App() {
  const initialproductList = [
    {
      price: 35,
      name: "Tomato",
      Quantity: 0,
    },
    
  ]
  let [productList, setProductList] = useState(initialproductList)
  let [totalAmount, setTotalAmount] = useState(0)

  const incrementQuantity = (index)=>{
    let newProductList =[...productList]
    let newTotalAmount =totalAmount;
    newTotalAmount += newProductList[index].price
    newProductList[index].Quantity++
    setTotalAmount(newTotalAmount);
    setProductList(newProductList)

  }
  const decrementQuantity = (index)=>{
    let newProductList =[...productList]
    let newTotalAmount =totalAmount;
    if(newProductList[index].Quantity >0 ){
      newProductList[index].Quantity--;
      newTotalAmount -=newProductList[index].price;
    }
    setTotalAmount(newTotalAmount);
    setProductList(newProductList)
  }
  const resetQuantity = ()=>{
    let newProductList = [...productList];
    newProductList.map((products)=>{
      products.Quantity = 0;
    })
    setProductList(newProductList);
    setTotalAmount(0);
  }
  const removeItem = (index)=>{
    let newProductList = [...productList];
    let newTotalAmount =totalAmount;
    
    newTotalAmount -= newProductList[index].Quantity * newProductList[index].price;
    newProductList.splice(index, 1);
    setProductList(newProductList);
    setTotalAmount(newTotalAmount);
  }
  const addItem = (name, price)=>{
    let newProductList = [...productList];
    newProductList.push ({
      price : price,
      name : name,
      Quantity : 0
    })
    setProductList(newProductList);

  }
  return (
    <>
       <div>
        <Toaster
          position="top-right"
          toastOptions={{
            success: {
              iconTheme: {
                primary: "#62bd6e",
              },
            },
            error: {
              iconTheme: {
                primary: "#e3776f",
              },
            },
          }}
        />
        </div>
      <Navbar />
      <main className='container mt-4'>
        <AddItem addItem = {addItem}/>
        <ProductList productList={productList} incrementQuantity={incrementQuantity} 
                          decrementQuantity={decrementQuantity} removeItem={removeItem}/>
      </main>
      <Footer totalAmount = {totalAmount} resetQuantity = {resetQuantity}/>
    </>
  );
}

export default App;
